import { Grid, Typography } from '@mui/material';
import { ReactNode } from 'react';
import Button from 'domains/core/components/Button';
import { trackCuredEvent, MixpanelEvent, MixpanelFlow } from 'helpers/initMixpanel';
import { FilterValuesState } from '../types';

const wrapperStyles = {
    border: '1px solid',
    borderColor: 'other.divider',
    borderRadius: 1,
    padding: 3,
};

type Props = {
    children: ReactNode;
    disabled?: boolean;
    handleApplyFilters: () => void;
    dashboardType: string;
    filterValues: FilterValuesState;
};

const FiltersWrapper = ({ children, disabled, handleApplyFilters, dashboardType, filterValues }: Props) => {
    const handleApplyFiltersWithTracking = () => {
        // Extract filter properties for tracking
        const curationNames = filterValues.selectedCurationsValue?.map((c) => c.campaign_name) || [];
        const sendNames = filterValues.selectedSendsValue?.map((s) => s.send_name) || [];
        const specialties = filterValues.selectedSpecialtiesValue || [];

        // Build timeframe tracking data
        let timeframeData: any = {};
        if (filterValues.filterTimeframe) {
            timeframeData = {
                start_date: filterValues.filterTimeframe.start?.toISODate(),
                end_date: filterValues.filterTimeframe.end?.toISODate(),
            };
        } else if (filterValues.filterRelativeTimeframe) {
            timeframeData = {
                relative_timeframe: {
                    direction: filterValues.filterRelativeTimeframe.direction,
                    duration: filterValues.filterRelativeTimeframe.duration,
                    unit: filterValues.filterRelativeTimeframe.unit,
                },
            };
        }

        // Track the event
        trackCuredEvent(
            MixpanelEvent.DASHBOARD_FILTERS_APPLIED,
            {
                dashboard_type: dashboardType,
                curation_names: curationNames.length > 0 ? curationNames : undefined,
                send_names: sendNames.length > 0 ? sendNames : undefined,
                specialties: specialties.length > 0 ? specialties : undefined,
                include_unsubscribes: filterValues.includesUnsubscribes,
                ...timeframeData,
            },
            MixpanelFlow.INSIGHTS
        );

        // Call the original handler
        handleApplyFilters();
    };

    return (
        <Grid item xs={12} sx={wrapperStyles}>
            <Typography variant="body1">Dashboard Filters</Typography>
            {children}
            <Button disabled={disabled} variant="outlined" onClick={handleApplyFiltersWithTracking}>
                Apply filters
            </Button>
        </Grid>
    );
};

export default FiltersWrapper;
